import { useState } from 'react';
import { TextField } from '@flos/react-ui';
import useAppState from '../../../state/appState';
import { ElementValue } from '../../../types/element-values';
import { FormValues } from '@topdanmark-onlinesolutions/claim-form-types';
import { FieldValueType, contentElementId, validationText } from './util';
import isNotEmpty from '../../../validators/is-not-empty';

const fieldLabel = {
    companyName: 'Forsikringsselskabets navn',
    policyNumber: 'Police-/forsikringsnummer'
};

const InsuranceCompany = () => {
    const { Forsikringsselskab } = contentElementId;
    const { companyNameId, policyNumberId } = Forsikringsselskab;

    const formValues = useAppState((state) => state.formValues);
    const setFormValue = useAppState((state) => state.setFormValue);

    const companyName = InsuranceCompany.getValueOrDefault(formValues, companyNameId);
    const policyNumber = InsuranceCompany.getValueOrDefault(formValues, policyNumberId);

    const [fieldHasHadFocusAtLeastOnce, setFieldHasHadFocusAtLeastOnce] = useState<
        Record<keyof typeof fieldLabel, boolean>
    >({
        companyName: false,
        policyNumber: false
    });

    return (
        <div className="u-spacing-stack-m other-company">
            <TextField
                required
                value={companyName.value}
                label={fieldLabel.companyName}
                errorText={validationText}
                isValid={fieldHasHadFocusAtLeastOnce.companyName ? isNotEmpty(companyName.value) : undefined}
                onFocus={() => setFieldHasHadFocusAtLeastOnce((field) => ({ ...field, companyName: true }))}
                onChange={({ target: { value } }) => {
                    setFormValue(companyNameId, {
                        label: fieldLabel.companyName,
                        value
                    });
                }}
            />
            <TextField
                required
                value={policyNumber.value}
                label={fieldLabel.policyNumber}
                errorText={validationText}
                isValid={fieldHasHadFocusAtLeastOnce.policyNumber ? isNotEmpty(policyNumber.value) : undefined}
                onFocus={() => setFieldHasHadFocusAtLeastOnce((field) => ({ ...field, policyNumber: true }))}
                onChange={({ target: { value } }) => {
                    setFormValue(policyNumberId, {
                        label: fieldLabel.policyNumber,
                        value
                    });
                }}
            />
        </div>
    );
};

InsuranceCompany.getValue = (formValues: FormValues, elementId: string): ElementValue => {
    const value = formValues[elementId];
    return value;
};

InsuranceCompany.getValueOrDefault = (formValues: FormValues, elementId: string) => {
    const value: FieldValueType | undefined = InsuranceCompany.getValue(formValues, elementId);

    if (value === undefined) {
        return { label: '', value: '' };
    }
    return value;
};

export default InsuranceCompany;
